module.exports = __webpack_public_path__ + "img/just_text_outline.f51f163b.png";